"use client";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { normalizeTotpInput } from "@/lib/auth/mfa-client";
import { cn } from "@/lib/utils";

/**
 * The 6-digit authenticator code field every two-factor surface shares:
 * numeric keyboard on phones, browser/iOS one-time-code autofill, and
 * paste-friendly (digits only, capped at six).
 */
export function TotpCodeInput({
  id,
  label,
  value,
  onChange,
  disabled,
  autoFocus,
  invalid,
  className,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  invalid?: boolean;
  className?: string;
}) {
  return (
    <div className={cn("space-y-2", className)}>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        name="one-time-code"
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        pattern="[0-9]{6}"
        maxLength={6}
        placeholder="123456"
        value={value}
        onChange={(event) => onChange(normalizeTotpInput(event.target.value))}
        disabled={disabled}
        autoFocus={autoFocus}
        aria-invalid={invalid || undefined}
        className="h-12 text-center font-mono text-2xl tracking-[0.5em]"
        required
      />
    </div>
  );
}
